<template>
    <div>
        <div class="text-center">
            <br>
                <h1 class="titlequestion">Revisar y reservar</h1>
            <br>
        </div>
        <div class="container">
      <div class="row">
        <div class="col-sm-4">
            <div class="row date">
              <div class="col-sm-6 border pt" @click="openCalendar1">
                <label class="green day pt">{{day(sendReservation.fecha_salida)}}</label>
                <label class="medium mouth pt">{{month(sendReservation.fecha_salida)}}<br>{{year(sendReservation.fecha_salida)}}</label>
                <img src="/img/flecha.png" class="flecha" alt="">
                <!-- <button class="btn btn-link btnSelect" @click="calendario_ent = !calendario_ent">
                  <i class="fa fa-chevron-down" aria-hidden="true"></i>
                  </button> -->
              </div>
              <div class="col-sm-6 border bckhour">
                <!-- <label class="green day">10:</label>
                <label class="medium mouth">00<br>00</label> -->
                <select class="custom-select selectHora" v-model="sendReservation.hora_salida">
                  <option class="horas" :value="'00:00:00'">00:00</option>
                  <option class="horas" :value="'00:30:00'">00:30</option>
                  <option class="horas" :value="'01:00:00'">01:00</option>
                  <option class="horas" :value="'01:30:00'">01:30</option>
                  <option class="horas" :value="'02:00:00'">02:00</option>
                  <option class="horas" :value="'02:30:00'">02:30</option>
                  <option class="horas" :value="'03:00:00'">03:00</option>
                  <option class="horas" :value="'03:30:00'">03:30</option>
                  <option class="horas" :value="'04:00:00'">04:00</option>
                  <option class="horas" :value="'04:30:0'">04:30</option>
                  <option class="horas" :value="'05:00:00'">05:00</option>
                  <option class="horas" :value="'05:30:00'">05:30</option>
                  <option class="horas" :value="'06:00:00'">06:00</option>
                  <option class="horas" :value="'06:30:00'">06:30</option>
                  <option class="horas" :value="'07:00:00'">07:00</option>
                  <option class="horas" :value="'07:30:00'">07:30</option>
                  <option class="horas" :value="'08:00:00'">08:00</option>
                  <option class="horas" :value="'08:30:00'">08:30</option>
                  <option class="horas" :value="'09:00:00'">09:00</option>
                  <option class="horas" :value="'09:30:00'">09:30</option>
                  <option class="horas" :value="'10:00:00'">10:00</option>
                  <option class="horas" :value="'10:30:00'">10:30</option>
                  <option class="horas" :value="'11:00:00'">11:00</option>
                  <option class="horas" :value="'11:30:00'">11:30</option>
                  <option class="horas" :value="'12:00:00'">12:00</option>
                  <option class="horas" :value="'12:30:00'">12:30</option>
                  <option class="horas" :value="'13:00:00'">13:00</option>
                  <option class="horas" :value="'13:30:00'">13:30</option>
                  <option class="horas" :value="'14:00:00'">14:00</option>
                  <option class="horas" :value="'14:30:00'">14:30</option>
                  <option class="horas" :value="'15:00:00'">15:00</option>
                  <option class="horas" :value="'15:30:00'">15:30</option>
                  <option class="horas" :value="'16:00:00'">16:00</option>
                  <option class="horas" :value="'16:30:00'">16:30</option>
                  <option class="horas" :value="'17:00:00'">17:00</option>
                  <option class="horas" :value="'17:30:00'">17:30</option>
                  <option class="horas" :value="'18:00:00'">18:00</option>
                  <option class="horas" :value="'18:30:00'">18:30</option>
                  <option class="horas" :value="'19:00:00'">19:00</option>
                  <option class="horas" :value="'19:30:00'">19:30</option>
                  <option class="horas" :value="'20:00:00'">20:00</option>
                  <option class="horas" :value="'20:30:00'">20:30</option>
                  <option class="horas" :value="'21:00:00'">21:00</option>
                  <option class="horas" :value="'21:30:00'">21:30</option>
                  <option class="horas" :value="'22:00:00'">22:00</option>
                  <option class="horas" :value="'22:30:00'">22:30</option>
                  <option class="horas" :value="'23:00:00'">23:00</option>
                  <option class="horas" :value="'23:30:00'">23:30</option>

                </select>
                
              </div>
            </div>
                <b-calendar today-variant="primary" v-show="calendario_sal" v-model="towDays" @context="contextDate"></b-calendar>
                
        </div>
        <div class="col-sm-1">
          
          <i class="fa fa-arrow-right" aria-hidden="true"></i>

        </div>
        <div class="col-sm-4">
            <div class="row date">
              <div class="col-sm-6 border pt" @click="openCalendar2">
                <label class="green day pt">{{day(sendReservation.fecha_entrega)}}</label>
                <label class="medium mouth pt">{{month(sendReservation.fecha_entrega)}}<br>{{year(sendReservation.fecha_entrega)}}</label>
                <img src="/img/flecha.png" class="flecha" alt="">
              </div>
              <div class="col-sm-6 border bckhour">
                <select class="custom-select selectHora" v-model="sendReservation.hora_entrega">
                  <option class="horas" :value="'00:00:00'">00:00</option>
                  <option class="horas" :value="'00:30:00'">00:30</option>
                  <option class="horas" :value="'01:00:00'">01:00</option>
                  <option class="horas" :value="'01:30:00'">01:30</option>
                  <option class="horas" :value="'02:00:00'">02:00</option>
                  <option class="horas" :value="'02:30:00'">02:30</option>
                  <option class="horas" :value="'03:00:00'">03:00</option>
                  <option class="horas" :value="'03:30:00'">03:30</option>
                  <option class="horas" :value="'04:00:00'">04:00</option>
                  <option class="horas" :value="'04:30:0'">04:30</option>
                  <option class="horas" :value="'05:00:00'">05:00</option>
                  <option class="horas" :value="'05:30:00'">05:30</option>
                  <option class="horas" :value="'06:00:00'">06:00</option>
                  <option class="horas" :value="'06:30:00'">06:30</option>
                  <option class="horas" :value="'07:00:00'">07:00</option>
                  <option class="horas" :value="'07:30:00'">07:30</option>
                  <option class="horas" :value="'08:00:00'">08:00</option>
                  <option class="horas" :value="'08:30:00'">08:30</option>
                  <option class="horas" :value="'09:00:00'">09:00</option>
                  <option class="horas" :value="'09:30:00'">09:30</option>
                  <option class="horas" :value="'10:00:00'">10:00</option>
                  <option class="horas" :value="'10:30:00'">10:30</option>
                  <option class="horas" :value="'11:00:00'">11:00</option>
                  <option class="horas" :value="'11:30:00'">11:30</option>
                  <option class="horas" :value="'12:00:00'">12:00</option>
                  <option class="horas" :value="'12:30:00'">12:30</option>
                  <option class="horas" :value="'13:00:00'">13:00</option>
                  <option class="horas" :value="'13:30:00'">13:30</option>
                  <option class="horas" :value="'14:00:00'">14:00</option>
                  <option class="horas" :value="'14:30:00'">14:30</option>
                  <option class="horas" :value="'15:00:00'">15:00</option>
                  <option class="horas" :value="'15:30:00'">15:30</option>
                  <option class="horas" :value="'16:00:00'">16:00</option>
                  <option class="horas" :value="'16:30:00'">16:30</option>
                  <option class="horas" :value="'17:00:00'">17:00</option>
                  <option class="horas" :value="'17:30:00'">17:30</option>
                  <option class="horas" :value="'18:00:00'">18:00</option>
                  <option class="horas" :value="'18:30:00'">18:30</option>
                  <option class="horas" :value="'19:00:00'">19:00</option>
                  <option class="horas" :value="'19:30:00'">19:30</option>
                  <option class="horas" :value="'20:00:00'">20:00</option>
                  <option class="horas" :value="'20:30:00'">20:30</option>
                  <option class="horas" :value="'21:00:00'">21:00</option>
                  <option class="horas" :value="'21:30:00'">21:30</option>
                  <option class="horas" :value="'22:00:00'">22:00</option>
                  <option class="horas" :value="'22:30:00'">22:30</option>
                  <option class="horas" :value="'23:00:00'">23:00</option>
                  <option class="horas" :value="'23:30:00'">23:30</option>

                </select>
              </div>
            </div>
            <b-calendar today-variant="primary" v-show="calendario_ent" v-model="fourDays" @context="contextDate2"></b-calendar>
        </div>
        <div class="col-sm-3 border edad">
            <select class="custom-select2 selectEdad" v-model="sendReservation.edad">
                  <option class="edad" :value="'23'">23</option>
                  <option class="edad" :value="'24'">24</option>
                  <option class="edad" :value="'25'">+25</option>
            </select>
        </div>

      </div>

      
        <div class="row mt-4">
        <div class="col-9">
          <input type="text" class="input-large" placeholder="código promocional o número de cuenta (opcional)" autocomplete="off">
        </div>
        <div class="col-3">
          <button v-if="accion_modificar" class="btnr" @click="modificarReservaFormulario({
                                                                                  num_reserva:sendReservation.id, 
                                                                                  brand:3,
                                                                                  fecha_salida: sendReservation.fecha_salida,
                                                                                  fecha_entrada: sendReservation.fecha_entrega,
                                                                                  hora_salida:  sendReservation.hora_salida,
                                                                                  hora_entrada: sendReservation.hora_entrega
                                                                                  })">{{$t('buttons_label.continue')}}</button>
          <button v-else class="btnr" @click="">Continue</button>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import moment from 'moment'
    export default {
        computed: {
            ...mapState('reserva', ['sendReservation', 'calendario_sal', 'calendario_ent', 'accion_modificar']),
            towDays:
                    {
                        get()
                        {
                            //let day = moment().add(2, 'days').format('YYYY-MM-DD')
                            return this.sendReservation.fecha_salida 
                        },

                        set(date)
                        {
                            this.updateFirstCalendar(date)
                        }
                    },

            fourDays:
                    {
                        get()
                        {
                            //let day = moment().add(4, 'days').format('YYYY-MM-DD')
                            return this.sendReservation.fecha_entrega 
                        },

                        set(date)
                        {
                            this.updateSecondCalendar(date)
                        }
        
                    }
                },
            methods: {
                ...mapActions('reserva', ['updateDataReserve', 'modificarReservaFormulario']),
                ...mapMutations('reserva', [
                                  'contextDate', 
                                  'contextDate2', 
                                  'updateFirstCalendar', 
                                  'updateSecondCalendar', 
                                  'openCalendar1', 
                                  'openCalendar2',
                                  ]),
                // metodo para mostrar el día
                day(d){
                    return moment(d).format('D')
                },

                // metodo para mostrar el mes 
                month(m){
                    return moment(m).format('MMM')
                },

                // metodo para mostrar el año 
                year(y){
                    return moment(y).format('YYYY')
                }
            },
        }
</script>

<style lang="scss" scoped>
.heavy{
  font-family: DINHeavy, 'Arial Black', Arial, Helvetica, sans-serif;
  font-size: 32px;
  line-height: 36px;
}
a{
  line-height: 36px;
  span{
    color: #c3c3c3; 
    margin-top: 2px; 
    margin-right: 7px;
  }
}

.green, .green:hover {
    color: #169A5A;
}
.bold {
    font-family: DINBold, 'Arial Black', Arial, sans-serif;
    font-size: 15px;
}
.light {
    font-family: DINLight, Helvetica, Arial, sans-serif;
    font-size: 15px;
    padding-top: 33px;
}
.medium {
    font-family: DINMedium, Arial, sans-serif;
    font-size: 15px;
}
.input-large{
  border: 1px solid #c2c2c2; 
  height: 60px; 
  padding-left: 15px; 
  font-size: 20px; 
  width: 100%;
}
.input-sucursal{
  border: none; 
  height: 60px; 
  padding-left: 15px; 
  padding-right: 15px; 
  font-size: 20px; 
  width: 99%;
  background: url("/img/flecha.png") no-repeat right/1.4% ;
    background-color: rgb(255, 255, 255);
    
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.input-check{ 
  margin-top: 1.5%;
}
.btnr{
  background-color: #169A5A;
  color: white;
  border-radius: 0%;
  width: 100%;
  height: 100%;
}
.date{
  margin-left: 0%;
}
.day{
  padding-top: 10px; 
  padding-left: 15px; 
  font-size: 45px; 
  line-height: 54px;
}
.mouth{
  padding-top: 8px; 
  font-size: 13px; 
  height: 19px; 
  padding-bottom: 5px;
}
.fa-arrow-right{
  padding: 25px 27px;
}
.col-sm-1 {
    max-width: 7%;
}
.edad{
  margin-left: 3%;
  max-width: 22%;
}

.selectHora{
  width: 100%;
  font-size: 43px; 
  border: none;
  color:#169A5A;
  padding: 0px;

  .horas{
    color: white;
    font-size: 16px;
  } 
}
.bckhour{
  background-color: #f3f3f3;
}
.custom-select {
    background: url("/img/flecha.png") no-repeat right/10% ;
    background-color: #f3f3f3;
    border: 0px  #ffffff;
    border-radius: 0rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.custom-select2 {
    background: url("/img/flecha.png") no-repeat right/7% ;
    background-color: rgb(255, 255, 255);
    border: 0px  #ffffff;
    border-radius: 0rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.pt{
   cursor: pointer;
}
.flecha{
    position: absolute;
    margin-top: 19%;
    margin-left: 12%;
    width: 10%;
}

.selectEdad{
  width: 100%;
  background-color: #ffffff;
  font-size: 43px; 
  border: none;
  color:#169A5A;
  padding: 7px;

  .edad{
    color: white;
    font-size: 16px;
  } 
}

</style>